import { useContext } from "react";
import {
  getPageNumberByPosition,
  PageItemType,
} from "../../../../utilities/layout";
import { useLayoutProvider } from "../../utils/layout";
import { ItemRendererContext, MissingLayoutDimensionsError } from "./constants";

export function useItemRendererContext() {
  const context = useContext(ItemRendererContext);

  if (!context) {
    throw new Error("No ItemRenderer context was provided.");
  }

  return context;
}

export function useMakeCommonQuickKeyProps() {
  const { dragging } = useItemRendererContext();
  const { pagesController, layoutDimensions } = useLayoutProvider();

  const { currentPage } = pagesController;

  if (!layoutDimensions) throw new MissingLayoutDimensionsError();

  const makeCommonQuickKeyProps = (item: PageItemType) => {
    const pageNumber = getPageNumberByPosition(layoutDimensions, item.position);
    const droppable = pageNumber === currentPage;

    return {
      item,
      dragging,
      draggable: true,
      droppable,
    };
  };

  return {
    makeCommonQuickKeyProps,
  };
}
